<template>
  <div class="panels flex">
    <div :key="index" class="row" v-for="(item, index) in list">
      <div class="imggs flex">
        <div class="demo-image__preview">
          <el-image
            :src="$config.imgIp + item.pic"
            :preview-src-list="imgList"
            class="imgs"
          ></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { findOrgCompanyHonorByorgOrgCompanyId } from "@/api/base";
export default {
  computed: {
    ...mapGetters(["map", "graphic"])
  },
  data() {
    return {
      list: [],
      imgList: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      findOrgCompanyHonorByorgOrgCompanyId({ companyId: this.graphic.id }).then(
        res => {
          res.data.map(it => {
            this.imgList.push(this.$config.imgIp + it.pic);
          });
          this.list = res.data;
        }
      );
    }
  }
};
</script>

<style lang="stylus" scoped>
.imggs
  background url('~images/index/home/qy_img.png') no-repeat center
  background-size 100% 100%
  height calc(100% - 10px)
  width calc(100% - 10px)
  z-index 12
  top 0
  left 0
  padding 5px
  justify-content center
.panels
  height 100%
  overflow-y auto
  flex-wrap wrap
  // align-items flex-start
  // justify-content space-around
  .row
    text-align center
    position relative
    font-size 12px
    width 31%
    height 0.54rem
    margin-right 2%
    img
      width 100%
  .num
    font-size 26px
  &::-webkit-scrollbar
    width 3px
  /* 定义滚动条轨道 内阴影+圆角 */
  &::-webkit-scrollbar-track
    -webkit-box-shadow inset 0 0 6px transparent
    background-color transparent
  /* 定义滑块 内阴影+圆角 */
  &::-webkit-scrollbar-thumb
    border-radius 10px
    -webkit-box-shadow inset 0 0 6px transparent
    background-color $textColor
  /* 定义最上方和最下方的按钮 */
  &::-webkit-scrollbar-button
    height 0
.el-image
  >>>.el-image-viewer__close
    color #fff
    top 15px
@media (max-width 1280px)
  .tableBody
    font-size 0.08rem
</style>
